import { render } from "./SubjectManagement.vue?vue&type=template&id=04aa76d7&scoped=true"
import script from "./SubjectManagement.js?vue&type=script&lang=js"
export * from "./SubjectManagement.js?vue&type=script&lang=js"

import "./SubjectManagement.vue?vue&type=style&index=0&id=04aa76d7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aa76d7"]])

export default __exports__